<template>
    <section class="club-management main-body">
        <div class="clubs">
            <MiniHeader
                :heading="`Clubs User`"
                :buttonText="'Add Club User'"
                :hasButton="true"
                @buttonClicked="createClub()"
            >
                <router-link></router-link>
            </MiniHeader>
            <div class="search-users">
                <div class="search-users__section search-users__section--select">
                    <label
                        for="field"
                        class="search-users__label"
                    >Field to search</label>
                    <v-select
                        id="field"
                        item-text='name'
                        item-value='value'
                        :items="searchOptions"
                        v-model="searchFieldParameter"
                        solo
                        flat
                    ></v-select>
                </div>
    
                <div class="search-users__section search-users__section--text-field">
                    <label
                        for="search-text"
                        class="search-users__label"
                    >Starts with:</label>
                    <v-text-field
                        id="search-text"
                        placeholder=""
                        solo
                        flat
                        clearable
                        v-model="searchText"
                    ></v-text-field>
                </div>
                <div class="search-users__section">
                    <v-btn
                        :disabled="searchText === '' || searching"
                        accent
                        type="button"
                        @click="getAllClubUsers()"
                    >
                        Search Users
                    </v-btn>
                </div>
            </div>
            <div v-if="clubUsers.length > 0">
                <club-user-listing :clubUsers="clubUsers" />
            </div>
            <div v-else>
                <div>No users to display</div>
            </div>
        </div>

        <div class="pagination">
            <v-pagination
                v-if="pageCount"
                v-model="pageNumber"
                :length="pageCount"
                :total-visible="10"
                circle
                color="accent"
            />
        </div>
        <router-view></router-view>
    </section>
</template>

<script>
import axios from "axios"
import MiniHeader from "../../components/Library/MiniHeader.vue"
import  ClubUserListing from "./ClubUserListing.vue"
export default {
    name: "ClubUserManagement",

    components: {
        MiniHeader,
        ClubUserListing,
    },
    data: () => ({
        api: `${process.env.VUE_APP_CLUBSAPI}`,
        allClubUsers: [],
        allClubSearchUsers: [],
        clubUsers: [],
        pageNumber: 1,
        pageSize: 10,
        pageCount: null,
        searchFieldParameter: "email",
        searchText: "",
        searching: false,
        searchOptions: [
            { name: "Email", value: "email" },
            { name: "Given Name", value: "given_name" },
            { name: "Family Name", value: "family_name" },
        ]
    }),
    
    mounted() {
        this.getAllClubUsers()
    },
    watch: {
        pageNumber() {
            this.getAllClubUsers()
        },

        searchText(newValue) {
            if (newValue === '' || newValue === null) {
                this.getAllClubUsers();
            }
        }
    },

    methods: {
        paginate(array) {
            const start = (this.pageNumber - 1) * this.pageSize;
            return array.slice(start, start + this.pageSize);
        },
        getAllClubUsers() {
            this.$store.commit("startLoading");
            this.$getCurrentUserJwToken().subscribe((jwt) => {

                let url = `${this.api}/users`;
                
                axios({
                    method: "GET",
                    url,
                    params: {
                        field: this.searchFieldParameter || undefined,
                        filter: this.searchText || undefined,
                        "page.number": this.pageNumber,
                        "page.size": this.pageSize
                    },
                    headers: { Authorization: jwt },
                })
                .then((response) => {
                    this.clubUsers = response.data.data;
                    this.pageCount = response.data.meta.totalPages;
                })
                .catch((e) => {
                    console.error("Unable to load club users:", e);
                })
                .finally(() => {
                    this.$store.commit("completeLoading");
                });
            });
        },

        createClub () {   
            this.$router.push({
                name: "Create Club User",
                path: "/clubuser/create"
            })
        }
    }
}
</script>
<style lang=scss>
.search-users {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 16px;
    padding: 16px 8px;
    background-color: #fff;
    border: 1px solid #ccc;

    &__section {
        padding: 0 8px;

        &--select {
            width: 170px;
        }

        &--text-field {
            width: 50%;
        }
    }

    &__label {
        display: block;
        margin: 0 0 4px;
    }
}

.create-buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    &__add-entitlement {
        margin-left: 16px;
    }
}

.search-users-toggle {
    padding: 4px 8px;
    margin: 0 8px 0 0;
    opacity: 0.6;

    &.is-active {
        color: #fff;
        background: #67247c;
        opacity: 1;
    }
}
</style>